function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon - Menu - Customers",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 .787A.786.786 0 0 1 .788 0H2.28a1.838 1.838 0 0 1 1.66 1.05h13.487a1.312 1.312 0 0 1 1.266 1.65l-1.014 3.767A5.791 5.791 0 0 0 11.13 9.45H5.6l.177.935a.79.79 0 0 0 .774.64H10.6a5.84 5.84 0 0 0-.1 1.05c0 .177.007.351.023.525h-3.97a2.36 2.36 0 0 1-2.32-1.92L2.54 1.788a.261.261 0 0 0-.259-.213H.788A.786.786 0 0 1 0 .787zm4.2 14.438a1.575 1.575 0 1 1 .788 1.365 1.576 1.576 0 0 1-.788-1.365zm7.35-3.15a4.725 4.725 0 1 1 4.725 4.725 4.726 4.726 0 0 1-4.725-4.725zm4.725 3.675a3.664 3.664 0 0 0 2.55-1.027 1.555 1.555 0 0 0-1.48-1.073h-2.14a1.558 1.558 0 0 0-1.48 1.073 3.664 3.664 0 0 0 2.55 1.027zm0-3.15a1.575 1.575 0 1 0-1.575-1.575 1.575 1.575 0 0 0 1.575 1.575z",
    transform: "translate(2 4)",
    style: {
      fill: "#a9b0b3"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomers);
export default __webpack_public_path__ + "static/media/IconCustomers.72756cdf79047945d6efc0f3d3d616f4.svg";
export { ForwardRef as ReactComponent };